// extracted by mini-css-extract-plugin
export var slide = "TestimonialsCarousel-module--slide--PuQ9E";